import { render, staticRenderFns } from "./ViewerImageOverlays.vue?vue&type=template&id=50288280&scoped=true"
import script from "./ViewerImageOverlays.vue?vue&type=script&lang=js"
export * from "./ViewerImageOverlays.vue?vue&type=script&lang=js"
import style0 from "./ViewerImageOverlays.vue?vue&type=style&index=0&id=50288280&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50288280",
  null
  
)

export default component.exports